// frontend/src/components/grid/ProductIdentityView.jsx
// (named ...View to avoid a case-insensitive-FS clash with productIdentity.js,
// the column-helpers seam in this same folder.)
// Presentational image + name + SKU identity — the ONE visual shared by the
// grid Product cell (ProductCell) and the item-picker autocomplete option
// (ItemOption). Pure display: callers resolve the values from their own row /
// option shape and pass them in. Keeps the thumbnail, the "No image / No SKU"
// indicators, and the layout in a single place so a grid and a dropdown never
// drift apart. A caller that draws the picture elsewhere — a variant row under
// its product row — passes showImage=false and gets the text alone.

import { Image as ImagePlaceholder } from '../../icons';
import { useState } from 'react';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import './ProductCell.css';

// A genuinely image-less item gets a dashed muted frame + "No image" tooltip so
// it reads as intentional-absent, not still-loading. A missing SKU renders muted
// "No SKU" — unless the caller opts out of the SKU line entirely (showSku=false).
export default function ProductIdentity({ imageUrl, name, sku, showSku = true, showImage = true }) {
  const [imgFailed, setImgFailed] = useState(false);
  const { t } = useTranslation();
  const hasImage = !!imageUrl && !imgFailed;

  return (
    <div className="product-cell">
      {showImage && (
        <Tooltip title={hasImage ? undefined : t('productCell.noImage')}>
          <div className={`product-cell__thumb${hasImage ? '' : ' product-cell__thumb--empty'}`}>
            {hasImage ? (
              <img src={imageUrl} alt="" loading="lazy" onError={() => setImgFailed(true)} />
            ) : (
              <ImagePlaceholder className="product-cell__thumb-placeholder" weight="thin" />
            )}
          </div>
        </Tooltip>
      )}
      <div className="product-cell__text">
        <div className="product-cell__nameline">
          <Tooltip title={name} describeChild>
            <span className="product-cell__name">{name}</span>
          </Tooltip>
        </div>
        {showSku && (sku
          ? <span className="product-cell__sku">{sku}</span>
          : <span className="product-cell__sku product-cell__sku--empty">{t('productCell.noSku')}</span>)}
      </div>
    </div>
  );
}
